export default "__VITE_ASSET__BCyMaHpg__"